import { em } from 'polished'
import styled, { css } from 'styled-components'

export const WindowControls = styled.div`
  width: ${em(6)};
  height: ${em(6)};
  margin-left: ${em(10)};
  border-radius: 50%;
`

export const WindowHeader = styled.div`
  display: flex;
  flex: 0 0 ${em(25)};
  justify-content: flex-start;
  align-items: center;
  height: ${em(25)};
`

export const Window = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  position: relative;
  border-top-left-radius: ${em(5)};
  border-top-right-radius: ${em(5)};
  overflow: hidden;
  min-width: ${em(756)};

  ${({ colorTheme }) =>
    colorTheme !== 'dark' &&
    css`
      border: 1px solid ${p => p.theme.colors.blackOp1};
      background: ${p => p.theme.colors.white};
    `}

  ${WindowHeader} {
    background: ${p =>
      p.colorTheme === 'dark'
        ? p.theme.colors.mineShaft
        : p.theme.colors.blackOp1};
  }

  ${WindowControls} {
    background: ${p =>
      p.colorTheme === 'dark' ? p.theme.colors.whiteOp1 : p.theme.colors.white};
  }
`

export const Frame = styled.div`
  position: relative;
  width: 100%;
  background: ${p => p.theme.colors.white};
`

export const ImageBox = styled.div`
  width: 100%;
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: ${p => p.theme.animation.timeBtns};
  overflow: hidden;
  
  ${({ state }) =>
    state === 'entering' &&
    css`
      opacity: 0;
      transform: translateY(${em(40)});
      transition-duration: 0s;
      z-index: 1;
    `}

  ${({ state }) =>
    state === 'entered' &&
    css`
      opacity: 1;
      transform: translateY(0);
      transition-duration: ${p => p.theme.animation.timeBtns};
    `}
  
  ${({ state }) =>
    (state === 'exiting' || state === 'exited') &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transform: translateY(20%);
      z-index: 2;
    `}
`
